module.exports = __webpack_public_path__ + "img/emoji-happy-on.53c89d68.svg";